import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "axios"

const { REACT_APP_API_ROUTE: API_ROUTE } = process.env

const initialState = {
  status: "idle",
  data: null,
  error: "",
}

export const auxSlice = createSlice({
  name: "aux",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(findAll.pending, (state, action) => {
      state.status = "loading"
    })
    builder.addCase(findAll.fulfilled, (state, action) => {
      state.status = "succeeded"
      state.data = action.payload
    })
    builder.addCase(findAll.rejected, (state, action) => {
      state.status = "failed"
      state.error = action.payload
    })
  },
})

export const findAll = createAsyncThunk("/aux", async (arg, thunkAPI) => {
  try {
    const endpoint = "/aux"
    const { data } = await axios.get(API_ROUTE + endpoint)
    return thunkAPI.fulfillWithValue(data)
  } catch (ex) {
    console.log(ex)
    return thunkAPI.rejectWithValue(ex.message)
  }
})
export const getAux = (state) => state.aux
export default auxSlice.reducer
